import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUnits } from '../../hooks';
import { CupIcon } from '../icons';
export function ChallengeObjective({
  challenge
}) {
  const {
    t
  } = useTranslation();
  const {
    toDistance
  } = useUnits();
  if (challenge && challenge.type === 'noTarget') return /*#__PURE__*/React.createElement(React.Fragment, null);
  const collaborationContext = challenge?.subGroupDisplay === 'companySite' ? 'sites' : challenge?.collaborationType;
  const targetCollaborationContext = challenge && collaborationContext ? challenge.targetValue ? collaborationContext : `${collaborationContext}_no_target` : undefined;
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(CupIcon, {
    color: challenge ? 'primary' : 'action',
    sx: {
      fontSize: 24
    }
  }), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontWeight: 700,
      fontSize: 16
    },
    variant: "body2"
  }, challenge ? challenge.type === 'bttf' ? t('commons.challenges.types.bttf_description', {
    context: targetCollaborationContext,
    count: challenge.targetValue
  }) : challenge.type === 'custom' ? t('commons.challenges.types.custom_description', {
    context: targetCollaborationContext,
    count: challenge.targetValue
  }) : challenge.type === 'traveledDistance' ? t('commons.challenges.types.distance_description', {
    context: targetCollaborationContext,
    distance: toDistance(challenge.targetValue)
  }) : challenge.type === 'cyclingDays' ? t('commons.challenges.types.cycling_days_description', {
    context: collaborationContext,
    count: challenge.targetValue
  }) : t('commons.challenges.types.journeys_description', {
    context: collaborationContext,
    count: challenge.targetValue
  }) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  })), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "caption"
  }, challenge ? challenge.traceType === 'commuting' || challenge.type === 'homeWorkJourneysCount' ? t('commons.challenges.types.considered_journeys_home_work') : t('commons.challenges.types.considered_journeys_all') : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  }))));
}